/* eslint-disable react-hooks/rules-of-hooks */
import { Storage } from "aws-amplify";

export const uploadProfilePic = async (file, userName) => {
  //file-> res.file.originFileObj
  //userName-> userName (/username)
  const key = `${userName}/profile-pic/${file?.name}`;

  const fileUploadResponse = await Storage.put(key, file, {
    level: "public", //change it to private
    contentType: file.type, // contentType is optional
    metadata: {
      key: key,
      type: file.type,
    },
  });
  return fileUploadResponse;
};

export const uploadServicesPic = async (file, userName, prefix="images") => {
  //file-> res.file.originFileObj
  //id->n service id
  //userName-> userName (/username)
  const key = `${userName}/${prefix}/${replaceFileName(file?.name)}`
  

  const fileUploadResponse = await Storage.put(key, file, {
    level: "public", //change it to private
    contentType: file.type, // contentType is optional
    metadata: {
      key: key,
      type: file.type,
    },
  });
  return fileUploadResponse;
};


export const replaceFileName = (name) => {
  const pattern = /[^a-zA-Z0-9.]/g;
  let fileName = `${name.replace(/\.[^/.]+$/, "")}.${name
    .replace(/(.*)\./g, "")
    .replace(/ /g, "_")}`;

  fileName = fileName.replace(pattern, "_");

  return fileName;
};